import { ReactComponent as Logo } from "assets/icons/iparque-base-logo.svg";
import { ReactComponent as UnsupportedBrowser } from "assets/images/unsupported-browser.svg";
import ContentContainer from "components/ContentContainer";
import FullPageContainer from "components/FullPageContainer";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

const addLineBreak = (translation: string) =>
  translation.replace(/<br\/>/g, "\n");

const UnsupportedBrowserPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FullPageContainer>
      <div>
        <StyledContentContainer>
          <StyledLogo />
          <Row>
            <Cell>
              <div>
                <UnsupportedBrowserImage preserveAspectRatio="xMinYMin meet" />
              </div>
              <TextContainer>
                <Title>{t("10780") /* Lamentamos */}</Title>
                <SubTitle>
                  {addLineBreak(
                    t(
                      "10781"
                    ) /* porém, este site utiliza tecnologias<br/>que o seu browser não suporta. */
                  )}
                </SubTitle>
                <Body>
                  {addLineBreak(
                    t(
                      "10782"
                    ) /* Recomendamos, por motivos de segurança,<br/>que atualize o seu browser. */
                  )}
                </Body>
              </TextContainer>
            </Cell>
          </Row>
        </StyledContentContainer>
      </div>
    </FullPageContainer>
  );
};

export default UnsupportedBrowserPage;

const StyledContentContainer = styled(ContentContainer)`
  @import url("https://fonts.googleapis.com/css2?family=Lato:wght@300&family=Raleway:wght@700&display=swap");

  overflow: hidden;
  display: table;
  padding: 65px 0 100px;
  box-sizing: border-box;
  min-height: 100vh;
`;

const StyledLogo = styled(Logo)`
  margin-bottom: 20px;
  margin-left: 20px;

  @media (max-width: ${breakpoints.md}) {
    margin-bottom: 100px;
  }
`;

const UnsupportedBrowserImage = styled(UnsupportedBrowser)`
  width: 90%;
  max-width: 450px;
  height: none;

  @media (max-width: ${breakpoints.md}) {
    max-width: 300px;
  }
`;

const Row = styled.div`
  display: table-row;
`;

const Cell = styled.div`
  display: table-cell;
  vertical-align: middle;
  white-space: nowrap;

  > * {
    display: inline-block;
    vertical-align: top;
    width: 50%;

    @media (max-width: ${breakpoints.md}) {
      display: block;
      width: auto;
      text-align: center;
    }
  }
`;

const TextContainer = styled.div`
  padding-top: 25px;
  padding-left: 20px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.lightest};

  @media (max-width: ${breakpoints.md}) {
    padding-left: 0;
  }
`;

const Title = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 48px;
`;

const SubTitle = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 24px;
  margin-top: 10px;
`;

const Body = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 18px;
  margin-top: 20px;
`;
